export const servicesAPI = [
    {
        id: '0x1',
        title: 'Complete Whitening Pack',
        likes: 99,
        date: 'July 15, 2015',
        author: 'Dr. Anwar Hossain',
        img: '/assets/img/services/s-1.jpg',
        description: "Teeth whitening is a simple process. Whitening products contain one of two tooth bleaches (hydrogen peroxide or carbamide peroxide). These bleaches break stains into smaller pieces, which makes the color less concentrated and your teeth brighter.",
        category: [
            'Dental Care',
            'Services'
        ]
    },
    {
        id: '0x2',
        title: 'Sedation Dentistry',
        likes: 168,
        date: 'July 9, 2015',
        author: 'Dr. Asifur Rahman',
        img: '/assets/img/services/s-2.jpg',
        description: "Sedation dentistry refers to the use of pharmacological agents to calm and relax a patient prior to and during a dental appointment. The pharmacological agents usually belong to a class of drugs called sedatives, which exert their action by depressing the central nervous system, specifically those areas concerned with conscious awareness. There are different degrees of central nervous system depression, each corresponding to a level of relaxation which ranges from minimal, moderate, to deep sedation. In general, minimal sedation refers to a patient who has reduced anxiety but readily responds to verbal or physical stimulation. With moderate sedation the patient is even more relaxed, and will respond to purposeful stimulation. In deep sedation, the patient may not exhibit any signs of consciousness and therefore be unresponsive to stimulation.",
        category: [
            'Dental Care',
            'Services'
        ]
    },
    {
        id: '0x3',
        title: 'Cosmetic Dentistry',
        likes: 201,
        date: 'July 9, 2015',
        author: 'Dr. Abrar Hossain',
        img: '/assets/img/services/s-3.jpg',
        description: "Cosmetic dentistry is dentistry aimed at creating a positive change to your teeth and to your smile. The American Academy of Cosmetic Dentistry (AACD) is the primary dental resource for patients as they strive to maintain their health, function, and appearance for their lifetime. We believe that esthetic dentistry must complement the overall general and oral health of the patient.",
        category: [
            'Special Service',
            'Services'
        ]
    },
    {
        id: '0x4',
        title: 'Cleaning with Air Flow',
        likes: 167,
        date: 'July 9, 2015',
        author: 'Dr. Abrar Hossain',
        img: '/assets/img/services/s-4.jpg',
        description: "Airflow Polish is a system that has been designed to deep clean the teeth and gums. It works by applying a high-powered combination of compressed air, water, and fine powder particles to clean the teeth and gums of stains and dental plaque. As there is no direct contact with the teeth, the Airflow polish system is much gentler on the tooth’s surface and patients do not experience any sensitivity that they may do with traditional scaling.",
        category: [
            'Special Service',
            'New Services'
        ]
    },
    {
        id: '0x5',
        title: "Child's First Dental Visit",
        likes: 95,
        date: 'July 9, 2015',
        author: 'Dr. Abdur Rahman',
        img: '/assets/img/services/s-5.jpg',
        description: "Your child's first dental visit is to help your child feel comfortable with the dentist. The first dental visit is recommended by 12 months of age, or within 6 months of the first tooth coming in. The first visit often lasts 30 to 45 minutes. Depending on your child's age, the visit may include a full exam of the teeth, jaws, bite, gums, and oral tissues to check growth and development. If needed, your child may also have a gentle cleaning. This includes polishing teeth and removing any plaque, tartar, and stains. The dentist may show you and your child proper home cleaning such as flossing, and advise you on the need for fluoride. Baby teeth fall out, so X-rays aren’t often done. But your child's dentist may recommend X-rays to diagnose decay, depending on your child's age. X-rays are also used to see if the root of a jammed baby tooth may be affecting an adult tooth. In general, it is best that young children not have dental X-rays unless absolutely needed.",
        category: [
            'Dental Care',
            'Kids'
        ]
    },
    {
        id: '0x6',
        title: "Family Dental Care",
        likes: 50,
        date: 'July 11, 2015',
        author: 'Dr. Anwar Hossain',
        img: '/assets/img/services/s-6.jpg',
        description: "A family dentist is a dental practitioner who treats patients of all ages, from kids to adults. They offer a wide array of treatments, such as dental checkups, cleaning, examinations, fillings, x-rays, fluoride treatments, sealants, among others.",
        category: [
            'Dental Care',
            'Kids'
        ]
    },
]